// extracted by mini-css-extract-plugin
module.exports = {"cash-credit-differential":"CashCreditDifferential_cash-credit-differential__2tkOJ"};